import React from 'react';
import Navbar from '../components/Navbar';
import SearchBar from '../components/SearchBar';
import FooterBar from '../components/FooterBar';
import { GlobalStyle } from '../GlobalStyles';

const ErrorPage = () => {
  return (
    <div className='app-wrapper'>
      <Navbar />
      <SearchBar />
      <h1>Sorry we can't find that page</h1>
      <h3>Please the search or go back to the home page</h3>
      <FooterBar />
      <GlobalStyle />
    </div>
  );
};

export default ErrorPage;
